export { default as WindowEvents } from './WindowEvents.js';
export { default as YoutubeVideo } from './YoutubeVideo.js';
export { default as Accordeon } from './Accordeon.js';
export { default as Form } from './Form.js';
export { default as Ellipsis } from './Ellipsis.js';
export { default as Slider } from './Slider.js';
export { default as Footer } from './Footer.js';
export { default as Header } from './Header.js';
export { default as Maps } from './Maps.js';
export { default as UI } from './UI.js';
export { default as PageHistory } from './PageHistory.js';
export { default as PageVacancy } from './PageVacancy.js';
export { default as PageMain } from './PageMain.js';
export { default as PopupForms } from './PopupForms.js';
export { default as PageNews } from './PageNews.js';
export { default as Scroll } from './Scroll.js';


// WEBPACK FOOTER //
// ./_src/js/modules/index.js